module.exports = __webpack_public_path__ + "static/favicon-76b8347c53c5b084580ce27b02e2d288.png";